<!-- Vue's errorComponent for the external goal pickers' defineAsyncComponent. Mounted only
     when the picker's own JS chunk fails to load (stale hash after a redeploy, offline, etc).
     Vue caches a rejected async component loader, so nothing would otherwise mount and the
     host's goalLaunchPending flag (cleared only on `opened` or `requestUnmount`) would spin
     forever. This renders nothing visible, notifies the user, and immediately asks the host
     to unmount it. -->
<template>
	<div class="hidden"></div>
</template>

<script lang="ts">
export default {
	emits: ['requestUnmount'],

	mounted() {
		this.$notify({ text: this.$t('The goal selector could not be loaded. Please try again later.'), type: 'error' });
		this.$emit('requestUnmount');
	},
};
</script>
